export default function (app) {
    app.directive('ktsCancelPurchase', function () {
        return {
            template: require('./cancelpurchase.html'),
            controller: ['$scope', 'Restangular', '$state', function Controller($scope, Restangular, $state) {
                    $scope.authorize = function () {
                        var r = confirm("Are you sure you want to cancel the purchase?");
                        if (r === true) {
                            Restangular.one('purchases/purchase/cancel/' + $scope.purchase.id).get().then(function () {
                                $state.reload();
                            });
                        }
                    };
                }],
            scope: {
                purchase: '='
            }
        };
    });

}





// WEBPACK FOOTER //
// ./js/actions/cancelpurchase.js